/* ===================================================================
   NYLA Landing — theme JS
   Vanilla, no dependencies. Safe to run inside Theme Editor.
   =================================================================== */
(function () {
  'use strict';

  var NYLA = (window.NYLA = window.NYLA || {});
  NYLA.product = null;
  NYLA.selectedOptions = {};
  NYLA.selectedVariant = null;
  NYLA.selectedBundle = null;
  NYLA.packSelections = [];   // variant id chosen for each unit of a multi-pack
  NYLA.lineItems = [];        // grouped {variant_id, quantity} for submission
  NYLA.packContents = '';     // human-readable breakdown, e.g. "2× Lavande, 1× Nature"
  NYLA._packQty = 0;          // qty the current selectors were built for

  /* ---------- product data ---------- */
  function loadProduct() {
    var el = document.getElementById('nyla-product-data');
    if (!el) return;
    try { NYLA.product = JSON.parse(el.textContent); } catch (e) { NYLA.product = null; }
    if (NYLA.product && NYLA.product.variants && NYLA.product.variants.length) {
      NYLA.selectedVariant = NYLA.product.variants.find(function (v) { return v.available; }) || NYLA.product.variants[0];
    }
  }

  /* ---------- gallery ---------- */
  function initGallery() {
    var gal = document.querySelector('[data-gallery]');
    if (!gal) return;
    var slidesEl = gal.querySelector('[data-slides]');
    var slides = slidesEl ? slidesEl.children.length : 0;
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
    var cur = 0;
    if (slides <= 1) {
      var p = gal.querySelector('[data-prev]'), n = gal.querySelector('[data-next]');
      if (p) p.style.display = 'none';
      if (n) n.style.display = 'none';
    }
    function render() {
      if (slidesEl) slidesEl.style.transform = 'translateX(-' + cur * 100 + '%)';
      thumbs.forEach(function (t, i) { t.classList.toggle('active', i === cur); });
    }
    function go(i) { if (!slides) return; cur = (i + slides) % slides; render(); }
    var prev = gal.querySelector('[data-prev]'), next = gal.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
    // swipe
    var sx = 0;
    if (slidesEl) {
      slidesEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      slidesEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      });
    }

    // map media-id -> slide index so a variant can drive the hero image
    var mediaIndex = {};
    if (slidesEl) {
      Array.prototype.slice.call(slidesEl.children).forEach(function (slide, i) {
        var id = slide.getAttribute('data-media-id');
        if (id) mediaIndex[id] = i;
      });
    }
    NYLA.gallery = {
      go: go,
      goToMediaId: function (id) {
        if (id == null) return false;
        var idx = mediaIndex[String(id)];
        if (idx == null) return false;
        go(idx);
        return true;
      }
    };
  }

  /* ---------- swap the hero image to the selected variant's image ---------- */
  function showVariantImage() {
    var v = NYLA.selectedVariant;
    if (!v || !NYLA.gallery) return;
    NYLA.gallery.goToMediaId(v.featured_media_id);
  }

  /* ---------- variant (scent) selection ---------- */
  function resolveVariant() {
    if (!NYLA.product || !NYLA.product.variants.length) return;
    var groups = document.querySelectorAll('[data-option-index]');
    if (!groups.length) return;
    var chosen = [];
    groups.forEach(function (g) {
      var idx = +g.dataset.optionIndex;
      chosen[idx] = NYLA.selectedOptions[idx];
    });
    var match = NYLA.product.variants.find(function (v) {
      return chosen.every(function (val, i) { return val == null || v.options[i] === val; });
    });
    if (match) NYLA.selectedVariant = match;
    showVariantImage();
    updateOrderRecap();
  }

  function initVariants() {
    var groups = document.querySelectorAll('[data-option-index]');
    groups.forEach(function (g) {
      var idx = +g.dataset.optionIndex;
      var btns = g.querySelectorAll('[data-option-value]');
      // seed default from active button
      var active = g.querySelector('.scent.active');
      if (active) NYLA.selectedOptions[idx] = active.dataset.optionValue;
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          NYLA.selectedOptions[idx] = b.dataset.optionValue;
          var label = document.querySelector('[data-opt-current="' + idx + '"]');
          if (label) label.textContent = b.dataset.optionValue;
          resolveVariant();
        });
      });
    });
    resolveVariant();
  }

  /* ---------- bundles ---------- */
  function initBundles() {
    var wrap = document.querySelector('[data-bundles]');
    if (!wrap) return;
    var suffix = wrap.dataset.suffix || '';
    var bundles = Array.prototype.slice.call(wrap.querySelectorAll('[data-bundle]'));
    if (!bundles.length) return;

    function select(btn) {
      bundles.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      NYLA.selectedBundle = {
        id: btn.dataset.bundleId,
        qty: parseInt(btn.dataset.qty, 10) || 1,
        price: parseFloat(btn.dataset.price) || 0,
        compare: parseFloat(btn.dataset.compare) || 0,
        label: btn.dataset.label || '',
        suffix: suffix
      };
      // summary
      var sl = document.querySelector('[data-summary-label]');
      var st = document.querySelector('[data-summary-total]');
      if (sl) sl.textContent = NYLA.selectedBundle.qty + '× ' + NYLA.selectedBundle.label;
      if (st) st.textContent = NYLA.selectedBundle.price + ' ' + suffix;
      // broadcast to the order form
      document.dispatchEvent(new CustomEvent('nyla:bundle-change', { detail: NYLA.selectedBundle }));
    }

    bundles.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    var pre = wrap.querySelector('[data-preselected]') || bundles[0];
    select(pre);
  }

  /* ---------- order recap + hidden fields ---------- */
  function updateOrderRecap() {
    var form = document.querySelector('[data-order-form]');
    if (!form) return;
    var b = NYLA.selectedBundle;
    var v = NYLA.selectedVariant;
    var p = NYLA.product || {};

    var recapLabel = document.querySelector('[data-recap-label]');
    var recapTotal = document.querySelector('[data-recap-total]');

    if (b) {
      var parts = [b.qty + '× ' + b.label];
      if (v && v.title && v.title !== 'Default Title' && b.qty <= 1) parts.push(v.title);
      if (recapLabel) recapLabel.textContent = parts.join(' · ');
      if (recapTotal) recapTotal.textContent = b.price + ' ' + (b.suffix || '');
      // qty input mirrors bundle qty; locked when per-unit variant choosers are active
      var qtyInput = form.querySelector('[data-qty-input]');
      var packActive = !!document.querySelector('[data-pack-variants]:not([hidden])');
      if (qtyInput) {
        if (packActive) { qtyInput.value = b.qty; qtyInput.readOnly = true; }
        else { qtyInput.readOnly = false; if (!qtyInput.dataset.touched) qtyInput.value = b.qty; }
      }
    }

    set(form, '[data-f-bundle-id]', b ? b.id : '');
    set(form, '[data-f-bundle-label]', b ? b.label : '');
    set(form, '[data-f-bundle-qty]', b ? b.qty : '');
    set(form, '[data-f-bundle-price]', b ? b.price : '');
    set(form, '[data-f-variant-id]', v ? v.id : '');
    set(form, '[data-f-variant-title]', v ? v.title : '');
    set(form, '[data-f-product-id]', p.id || '');
    set(form, '[data-f-product-title]', p.title || '');

    // Build/refresh per-unit variant selectors, then recompute line items.
    renderPackVariants();
    syncLineItems();
  }
  function set(form, sel, val) { var el = form.querySelector(sel); if (el) el.value = val; }

  /* ---------- per-unit variant selectors for multi-packs ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getVariants() { return (NYLA.product && NYLA.product.variants) || []; }
  function hasRealVariants() {
    var vs = getVariants();
    return vs.length > 1 || (vs.length === 1 && vs[0].title && vs[0].title !== 'Default Title');
  }

  function renderPackVariants() {
    var box = document.querySelector('[data-pack-variants]');
    if (!box) return;
    var b = NYLA.selectedBundle;
    var allow = box.dataset.allowMix === 'true';
    var vs = getVariants();

    // Show when: mixing allowed AND product has real variants. One selector
    // per unit — so even a single item forces a parfum choice.
    if (!b || !allow || vs.length <= 1) {
      box.hidden = true;
      box.innerHTML = '';
      NYLA.packSelections = [];
      NYLA._packQty = 0;
      return;
    }

    // Already built for this quantity → keep the user's choices, don't rebuild.
    if (NYLA._packQty === b.qty && box.children.length) return;
    NYLA._packQty = b.qty;
    box.hidden = false;

    var defId = (NYLA.selectedVariant && NYLA.selectedVariant.id) || vs[0].id;
    var baseHeading = box.dataset.heading || 'Choisissez le parfum de chaque article';
    var heading = b.qty <= 1 ? 'Choisissez votre parfum' : baseHeading;
    var html = '<p class="pack-variants-title">' + escapeHtml(heading) + '</p>';
    NYLA.packSelections = [];

    for (var i = 0; i < b.qty; i++) {
      NYLA.packSelections[i] = defId;
      var rowLabel = b.qty <= 1 ? 'Parfum' : ('Article ' + (i + 1));
      html += '<label class="pack-variant-row"><span>' + rowLabel + '</span><select data-pack-slot="' + i + '">';
      vs.forEach(function (v) {
        var dis = v.available === false ? ' disabled' : '';
        var selAttr = String(v.id) === String(defId) ? ' selected' : '';
        html += '<option value="' + v.id + '"' + selAttr + dis + '>' + escapeHtml(v.title) + (v.available === false ? ' (épuisé)' : '') + '</option>';
      });
      html += '</select></label>';
    }
    box.innerHTML = html;

    box.querySelectorAll('[data-pack-slot]').forEach(function (s) {
      s.addEventListener('change', function () {
        NYLA.packSelections[+s.dataset.packSlot] = s.value;
        syncLineItems();
      });
    });
    syncLineItems();
  }

  /* ---------- build grouped line items + readable breakdown ---------- */
  function syncLineItems() {
    var form = document.querySelector('[data-order-form]');
    var vs = getVariants();
    var items = [];
    var contents = '';

    if (NYLA.packSelections && NYLA.packSelections.length) {
      // Group identical variants: [A,B,A] -> {A:2, B:1}
      var counts = {};
      NYLA.packSelections.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      Object.keys(counts).forEach(function (id) {
        items.push({ variant_id: id, quantity: counts[id] });
      });
      contents = Object.keys(counts).map(function (id) {
        var v = vs.find(function (x) { return String(x.id) === String(id); });
        return counts[id] + '× ' + (v ? v.title : id);
      }).join(', ');
    } else if (NYLA.selectedVariant) {
      var q = NYLA.selectedBundle ? NYLA.selectedBundle.qty : 1;
      items = [{ variant_id: NYLA.selectedVariant.id, quantity: q }];
      var t = NYLA.selectedVariant.title;
      contents = q + '× ' + (t && t !== 'Default Title' ? t : (NYLA.product ? NYLA.product.title : 'article'));
    }

    NYLA.lineItems = items;
    NYLA.packContents = contents;
    if (form) {
      set(form, '[data-f-pack-contents]', contents);
      var bd = form.querySelector('[data-recap-breakdown]') || document.querySelector('[data-recap-breakdown]');
      if (bd) bd.textContent = contents;
    }
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    document.querySelectorAll('[data-faq] .faq-item').forEach(function (item) {
      var q = item.querySelector('[data-faq-q]');
      var a = item.querySelector('.faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('open');
        document.querySelectorAll('[data-faq] .faq-item').forEach(function (f) {
          f.classList.remove('open');
          var fa = f.querySelector('.faq-a'); if (fa) fa.style.maxHeight = null;
          var fq = f.querySelector('[data-faq-q]'); if (fq) fq.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- order form submit ---------- */
  function initOrderForm() {
    var form = document.querySelector('[data-order-form]');
    if (!form) return;

    var qtyInput = form.querySelector('[data-qty-input]');
    if (qtyInput) qtyInput.addEventListener('input', function () { qtyInput.dataset.touched = '1'; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // honeypot
      if (form.querySelector('.hp') && form.querySelector('.hp').value) return;

      // validate required
      var valid = true;
      form.querySelectorAll('[required]').forEach(function (f) {
        var ok = !!String(f.value).trim();
        f.classList.toggle('invalid', !ok);
        if (!ok) valid = false;
      });
      if (!valid) {
        var first = form.querySelector('.invalid');
        if (first) first.focus();
        return;
      }

      var btn = form.querySelector('[data-submit]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Redirection vers le paiement…'; }

      // gather field values
      var data = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.name && el.type !== 'submit' && el.name !== 'company') data[el.name] = el.value;
      });

      // resolve the chosen line items (grouped by parfum/variant)
      syncLineItems();
      var items = (NYLA.lineItems || [])
        .filter(function (li) { return li.variant_id; })
        .map(function (li) {
          return {
            id: Number(li.variant_id),
            quantity: li.quantity,
            properties: { 'Parfum': variantTitle(li.variant_id) }
          };
        });

      function fail(msg) {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        alert(msg || 'Une erreur est survenue. Vérifiez votre connexion ou contactez-nous sur WhatsApp.');
      }

      if (!NYLA.product || !NYLA.product.available || !NYLA.product.id) {
        fail('Aucun produit n’est relié à cette page. Dans l’éditeur de thème → section Hero → choisissez le produit.');
        return;
      }
      if (!items.length) {
        fail('Veuillez choisir votre parfum avant de confirmer.');
        return;
      }

      // Customer info → cart note + attributes (shows on the Shopify order)
      var noteLines = [
        'Commande COD — Landing',
        'Nom: ' + (data.full_name || ''),
        'Téléphone: ' + (data.phone || ''),
        'Ville: ' + (data.city || ''),
        'Adresse: ' + (data.address || ''),
        'Offre: ' + (data.bundle_label || ''),
        'Parfums: ' + (NYLA.packContents || ''),
        'Notes: ' + (data.notes || '')
      ];
      var attributes = {
        'Nom': data.full_name || '',
        'Téléphone': data.phone || '',
        'Ville': data.city || '',
        'Adresse': data.address || '',
        'Offre': data.bundle_label || '',
        'Parfums': NYLA.packContents || '',
        'Notes client': data.notes || '',
        'Source': 'Landing COD'
      };

      // read Shopify's JSON error body so we show the real reason
      function asError(r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          var m = j && (j.description || j.message);
          throw new Error(m || ('HTTP ' + r.status));
        });
      }

      // Native cart flow: clear → add items → set note/attributes → checkout.
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.ok ? r.json() : asError(r); })
        .then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ note: noteLines.join('\n'), attributes: attributes })
          });
        })
        .then(function (r) { return r.ok ? r.json() : asError(r); })
        .then(function () {
          // Customer fills name/address/phone on Shopify checkout.
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('[NYLA] cart/checkout failed', err);
          fail('Impossible d’ajouter au panier : ' + (err && err.message ? err.message : 'erreur inconnue') +
               '\n\nVérifie que le produit est publié sur « Online Store » et qu’il est en stock.');
        });
    });
  }

  // helper: parfum/variant title from id
  function variantTitle(id) {
    var v = (NYLA.product && NYLA.product.variants || []).find(function (x) { return String(x.id) === String(id); });
    return v ? v.title : '';
  }

  /* ---------- chrome: header, sticky, reveal ---------- */
  function initChrome() {
    var header = document.querySelector('[data-header]');
    var sticky = document.querySelector('[data-sticky]');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (header) header.classList.toggle('scrolled', y > 10);
      if (sticky && window.innerWidth < 768) sticky.classList.toggle('show', y > 620);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    }
  }

  /* ---------- boot ---------- */
  function boot() {
    loadProduct();
    initGallery();
    initVariants();
    initBundles();
    initFaq();
    initOrderForm();
    initChrome();
    updateOrderRecap();
    document.addEventListener('nyla:bundle-change', updateOrderRecap);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
